import { IBrandOrder } from "@faire/web-api/indigofair/data/IBrandOrder";
import React from "react";
import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { ViewOrderDetailsCTA, ViewOrdersCTA } from "./ctas";
import { UpdateTrackingInfoIA } from "./instantAnswersComponents/orders/UpdateTrackingInfoIA";
export var updateTrackingInfo = function updateTrackingInfo(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    additionalRequiredData: [ShippingContextDataFn]
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_TRACKING_INFO_TITLE(context, strictLocalize);
    },
    getDescription: function getDescription() {
      return UPDATE_TRACKING_INFO_DESCRIPTION(context);
    }
  };
};
var UPDATE_TRACKING_INFO_TITLE = function UPDATE_TRACKING_INFO_TITLE(context, strictLocalize) {
  var shippingContext = context.shippingContext;
  if (!shippingContext) {
    return "";
  }
  var orderState = shippingContext.state;
  if (orderState === IBrandOrder.State.PROCESSING) {
    return strictLocalize({
      id: "2ERd1a",
      defaultMessage: [{
        "type": 0,
        "value": "Verzendinformatie bijwerken"
      }]
    });
  } else {
    return strictLocalize({
      id: "MtwBPq",
      defaultMessage: [{
        "type": 0,
        "value": "Tracking bijwerken voor een verzonden bestelling"
      }]
    });
  }
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return ViewOrderDetailsCTA(brandOrderToken, strictLocalize);
  }
  return ViewOrdersCTA(strictLocalize);
};
var UPDATE_TRACKING_INFO_DESCRIPTION = function UPDATE_TRACKING_INFO_DESCRIPTION(context) {
  var _context$brandOrder2;
  if (!context.shippingContext) {
    return [];
  }
  return /*#__PURE__*/React.createElement(UpdateTrackingInfoIA, {
    shippingContext: context.shippingContext,
    isSwf: (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : _context$brandOrder2.is_ship_with_faire
  });
};